export default "__VITE_ASSET__fadab2b8__"